import React, { useState } from 'react';
import"./qualification.css";

const Qualification = () => {
  const [toggleState, setToggleState] = useState(1);
  
  const toggleTab = (index) => {
    setToggleState(index);
  }

  return (
    <section className= "qualification section">
      <h2 className="section__title">Qualification</h2>
        <span className="section__subtitle">
            My Personal Journey
        </span>
          ``
        <div className="qualification__container container">
          <div className="qualification__tabs">
            <div className={
              toggleState === 1
                ? "qualification__button qualification__active button--flex"
                : "qualification__button button--flex"
              }
              onClick={() => toggleTab(1)}
            >
              <i className="uil uil-graduation-cap qualification__icon">
              </i> Education
            </div>
            
            <div className={
              toggleState === 2
                ? "qualification__button qualification__active button--flex"
                : "qualification__button button--flex"
              }
              onClick={() => toggleTab(2)}
            >
              <i className="uil uil-briefcase-alt qualification__icon">
              </i>Experience
            </div>
          </div>

          <div className="qualification__sections">
          
            <div className={
              toggleState === 1
                ? "qualification__content qualification__content-active"
                : "qualification__content"
              }
            >
            
              <div className="qualification__data">
                <div>
                  <h3 className="qualification__title">Aviation Information Technology (AIT)</h3>
                  <span className="qualification__subtitle">Philsca - Cebu  </span>
                  <div className="qualification__calendar">
                    <i className="uil uil-calendar-alt"></
                    i> 2010 - 2014
                  </div>
                </div>
                
                <div>
                  <span className="qualification__rounder"></span>
                  <div className="qualification__line"></div>
                </div>
              </div>
              
              <div className="qualification__data">
                <div></div>
                
                <div>
                  <span className="qualification__rounder"></span>
                  <span className="qualification__line"></span>
                </div>
                
                <div>
                  <h3 className="qualification__title">Bachelor Of Science & Information Technology (BSIT) </h3>
                  <span className="qualification__subtitle">Tacloban - ACLC </span>
                  <div className="qualification__calendar">
                    <i className="uil uil-calendar-alt"></
                    i> 2014 - 2018
                  </div>
                </div>
              </div>
              
              <div className="qualification__data">
                <div>
                  <h3 className="qualification__title">B.Tech</h3>
                  <span className="qualification__subtitle">New York - New York University </span>
                  <div className="qualification__calendar">
                    <i className="uil uil-calendar-alt"></
                    i> 2020 - 2021
                  </div>
                </div>

                <div>
                  <span className="qualification__rounder"></span>
                  <div className="qualification__line"></div>
                </div>
              </div>




            </div>

            <div className={
              toggleState === 2
                ? "qualification__content qualification__content-active"
                : "qualification__content"
              }
            >

              <div className="qualification__data">
                <div>
                  <h3 className="qualification__title">Junior Web Developer</h3>
                  <span className="qualification__subtitle">Bits & Bytes - Ormoc </span>
                  <div className="qualification__calendar">
                    <i className="uil uil-calendar-alt"></
                    i> 2018 - 2019
                  </div>
                </div>
                
                
                <div>
                  <span className="qualification__rounder"></span>
                  <div className="qualification__line"></div>
                </div>
              </div>
              
              <div className="qualification__data">
                <div></div>
                
                <div>
                  <span className="qualification__rounder"></span>
                  <span className="qualification__line"></span>
                </div>
                
                <div>
                  <h3 className="qualification__title">React Native Developer</h3>
                  <span className="qualification__subtitle">CoderBlitz - Taguig </span>
                  <div className="qualification__calendar">
                    <i className="uil uil-calendar-alt"></
                    i> 2019 - 2021
                  </div>
                </div>
              </div>
              
              <div className="qualification__data">
                <div>
                  <h3 className="qualification__title">Backend Developer</h3>
                  <span className="qualification__subtitle">IT Matters - Tacloban City </span>
                  <div className="qualification__calendar">
                    <i className="uil uil-calendar-alt"></
                    i> 2021 - 2023
                  </div>
                </div>
                
                <div>
                  <span className="qualification__rounder"></span>
                  <div className="qualification__line"></div>
                </div>
              </div>
              
              <div className="qualification__data">
                <div></div>
                
                <div>
                  <span className="qualification__rounder"></span>
                  <span className="qualification__line"></span>
                </div>
                
                <div>
                  <h3 className="qualification__title">FullStack Developer</h3>
                  <span className="qualification__subtitle">Microsoft - California </span>
                  <div className="qualification__calendar">
                    <i className="uil uil-calendar-alt"></
                    i> 2023 - Present
                  </div>
                </div>
              </div>
              
            </div>
            
          </div>
        </div>

    </section>
  )
}

export default Qualification